<template>
  <div class="gv-modern-prompts">
    <template v-if="kind === 'sound'">
      <div class="gv-design-grid" role="group" aria-label="Click for sound design">
        <button v-for="design in designs" :key="design.id" type="button"
          :aria-pressed="appearance.soundDesign === design.id ? 'true' : 'false'"
          :class="{ 'is-selected': appearance.soundDesign === design.id }"
          :data-design="design.id" @click="change('soundDesign', design.id)">
          <img :src="soundImage(design.id)" alt="" />
          <span>{{ design.label }}</span>
        </button>
      </div>
      <div class="gv-prompt-fields">
        <label>Animation<select :value="appearance.soundAnimation" @change="change('soundAnimation', $event.target.value)"><option v-for="name in animations" :key="name" :value="name">{{ animationLabel(name) }}</option></select></label>
        <label>Size<select :value="appearance.soundSize" @change="change('soundSize', $event.target.value)"><option value="small">Small</option><option value="regular">Regular</option><option value="large">Large</option></select></label>
      </div>
      <div class="gv-prompt-demo"><img :key="demoKey" :src="model.settings.autoplay_settings.custom_image" alt="Click for sound animation preview" /><button type="button" @click="demoKey++">Replay animation</button></div>
    </template>
    <template v-else>
      <div class="gv-prompt-fields">
        <label>Animation<select :value="appearance.playAnimation" @change="change('playAnimation', $event.target.value)"><option v-for="name in animations" :key="name" :value="name">{{ animationLabel(name) }}</option></select></label>
        <label>Size<select :value="appearance.playSize" @change="change('playSize', $event.target.value)"><option value="small">Small</option><option value="medium">Medium</option><option value="large">Large</option></select></label>
      </div>
      <div class="gv-prompt-demo"><img :key="demoKey" :src="model.play_button.custom_source" alt="Play button animation preview" /><button type="button" @click="demoKey++">Replay animation</button></div>
      <p class="gv-prompt-help">The play button follows your player theme and primary colour.</p>
    </template>
  </div>
</template>
<script>
import { SOUND_DESIGNS, MODERN_ANIMATIONS, soundImage, syncModernAppearance } from './newAppearance';
export default {
  name: 'ModernPrompts',
  props: { model: { type: Object, required: true }, kind: { type: String, default: 'sound' } },
  data: () => ({ designs: SOUND_DESIGNS, animations: MODERN_ANIMATIONS, demoKey: 0 }),
  computed: { appearance() { return this.model.settings.appearance; } },
  methods: {
    soundImage,
    animationLabel(name) { return name === 'none' ? 'None' : (name.charAt(0).toUpperCase() + name.slice(1)).replace(/([a-z])([A-Z])/g, '$1 $2'); },
    change(key, value) {
      this.$set(this.appearance, key, value);
      syncModernAppearance(this.model);
      this.demoKey++;
      this.$emit('change');
    },
  },
};
</script>
<style scoped>
.gv-modern-prompts { display: grid; gap: 16px; }
.gv-design-grid { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 8px; }
.gv-design-grid button { display: flex; flex-direction: column; align-items: center; min-width: 0; padding: 8px 4px 12px; border: 1px solid var(--gs-border); border-radius: 8px; background: var(--gs-surface); color: var(--gs-foreground); cursor: pointer; font-size: 12px; }
.gv-design-grid button.is-selected { border-color: var(--gs-primary); background: var(--gs-active-soft); }
.gv-design-grid img { width: 100%; height: 58px; object-fit: contain; }
.gv-prompt-fields { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 16px; }
.gv-prompt-fields label { display: grid; gap: 6px; font-size: 13px; font-weight: 600; }
.gv-prompt-fields select { width: 100%; padding: 10px; background: var(--gs-surface); color: var(--gs-foreground); border: 1px solid var(--gs-border); border-radius: 6px; }
.gv-prompt-demo { display: flex; align-items: center; justify-content: space-between; gap: 8px; min-height: 128px; padding: 8px 16px; border-radius: 8px; background: #202333; }
.gv-prompt-demo img { height: 96px; max-width: 75%; object-fit: contain; }
.gv-prompt-demo button { color: white; font-size: 12px; text-decoration: underline; background: none; border: 0; cursor: pointer; }
.gv-prompt-help { font-size: 13px; color: var(--gs-muted-foreground); }
button:focus-visible, select:focus-visible { outline: 2px solid var(--gs-primary); outline-offset: 2px; }
@media(max-width:640px) { .gv-design-grid { grid-template-columns: repeat(2,minmax(0,1fr)); } }
</style>
